import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { createQueryStringHook } from "../../../../stores/useQueryState";
import { RoundButton } from "../../../../ui/Button/Button";
import { Input } from "../../../../ui/Input/Input";
import { CrossIcon } from "../../../../ui/icons/CrossIcon";
import { Label } from "../Label/Label";

export const useOrdersCriteriaParam = createQueryStringHook("q", "");

export const CriteriaInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const [value, setValue] = useOrdersCriteriaParam();
  return (
    <fieldset className="md:ml-auto">
      <Label htmlFor="criteria-filter">{t("orderFilters.search")}</Label>
      <Input
        after={
          value && (
            <RoundButton
              onClick={(): void => {
                setValue("");
              }}
              aria-label="resetSearchCriteria"
              type="button"
            >
              <CrossIcon />
            </RoundButton>
          )
        }
        onChange={(event): void => {
          setValue(event.target.value);
        }}
        aria-label="searchCriteria"
        className="w-full"
        placeholder={t("orderFilters.typeToSearch")}
        value={value}
      />
    </fieldset>
  );
};
